type ClarityFn = (cmd: string, ...args: unknown[]) => void;

export function identifyUser(userId: string): void {
  (window as unknown as { clarity?: ClarityFn }).clarity?.('identify', userId);
}

export function loadClarity(): void {
  if (import.meta.env['VITE_CLARITY_ENABLED'] !== 'true') return;
  const clarityId = import.meta.env['VITE_CLARITY_PROJECT_ID'] ?? 'wmxr96xmr7';
  type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] };
  const win = window as Window & { clarity?: ClarityFn };
  const queueCall: ClarityFn = (...args: unknown[]) => {
    queueCall.q ??= [];
    queueCall.q.push(args);
  };
  win.clarity ??= queueCall;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${clarityId}`;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
